import {createReducer, on} from '@ngrx/store';
import * as GlobalConfigActions from './global-config.actions';
import {GlobalConfigDTO} from '../../utils/dto/global-config';

export interface GlobalConfigState {
  config: GlobalConfigDTO | null;
  loaded: boolean;
}

export const initialState: GlobalConfigState = {
  config: null,
  loaded: false,
};

export const globalConfigReducer = createReducer(
  initialState,
  on(GlobalConfigActions.loadGlobalConfigSuccess, (state, {config}) => ({
    ...state,
    config,
    loaded: true,
  })),
  on(GlobalConfigActions.loadGlobalConfigFailure, (state) => ({
    ...state,
    loaded: true,
  }))
);
